import { documentBundleActions } from 'src/redux/actions/constant';

const {
  SUCCESS_GET_PATIENT_FILTERS,
  FAILURE_GET_PATIENT_FILTERS,
  LOADING_GET_PATIENT_FILTERS,
  RESET_GET_PATIENT_FILTERS,
} = documentBundleActions;

const initialState = {
  response: null as any,
  loading: false,
};

export const getPatientFiltersReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_GET_PATIENT_FILTERS:
      return { ...state, loading: true };
    case SUCCESS_GET_PATIENT_FILTERS:
      return { ...state, loading: false, response: action.payload };
    case FAILURE_GET_PATIENT_FILTERS:
      return { ...state, loading: false, response: null };
    case RESET_GET_PATIENT_FILTERS:
      return initialState;
    default:
      return state;
  }
};
